import type { Answer, Dashboard } from './types'

// MPD-84 N1: a pinned card whose view the server refuses under the supplier scope (run-spec 403,
// code "out_of_scope") shows this state instead of figures. Its stored contract is replaced by
// OUT_OF_SCOPE_CONTRACT, so the old snapshot leaves the saved dashboard and never reappears offline.
export const OUT_OF_SCOPE_TEXT = 'Not available in your scope'
export const OUT_OF_SCOPE_INFO = 'This view uses data outside the segments your account covers. You can delete the card.'
export const OUT_OF_SCOPE_CONTRACT: Answer = { answer: OUT_OF_SCOPE_TEXT, caveat: null, chart: null }

// MPD-91 L1: an admin's "View as supplier" refreshes the admin's OWN boards under the previewed
// scope. A refusal there is shown as view state only: the stored card (flag and snapshot) is never
// touched, so the admin's figures come back as soon as the preview ends. Only a real supplier
// session persists the state above.
export function withPreviewOutOfScope(board: Dashboard, ids: ReadonlySet<string>): Dashboard {
  if (!ids.size || !board.cards.some((c) => ids.has(c.id))) return board
  return { ...board, cards: board.cards.map((c) => c.type === 'chart' && ids.has(c.id)
    ? { ...c, out_of_scope: true, last_contract: OUT_OF_SCOPE_CONTRACT } : c) }
}
